

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface PatientVaccineParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientVaccine {
    
    RegId:string;
    Weight?:number;
    Height?: number;
    HeadCirumference?: number;
    Batchnum?:string;
    Given:string
    Notes?:string;
    timeslotId:number;
    ExpiryDate?:any;
    MedicineId?:string;
    // Added new fields:-
    vaccineDoneOutsideFlag?:boolean;
    BvsId:number;
    DueDate?:any;
    givenDatetime?:any;
    visitId:number;

    parameters?: PatientVaccineParameter[];
    links?: any;
    createdBy?:Number;
    doseNumber?:number;
}


export abstract class PatientVaccineData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<PatientVaccine[]>;
    abstract create(url: string, data: any): Observable<any[]>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract getById(url: string): Observable<any>;
}
